<template>
  <div class='product-details'>
    <dean-two-column-layout :title="headerTitle">
      <dean-section-title-item
          :icon="saveIcon"
          slot="title-items"
          :content="true"
          :large="true"
          @click.native="save"
      >
        Opslaan
      </dean-section-title-item>
      <div class="column" slot="left">
        <dean-form-row id="name" label="naam" v-model="data.name" type="text" :required-field="true"
                       :warning="$v.data.name.$error" @focus="$v.data.name.$touch()"/>
        <dean-form-row id="length" label="aantal" v-model="data.length" type="number" :required-field="true"
                       :warning="$v.data.length.$error" @focus="$v.data.length.$touch()"/>
        <dean-select-form-row id="unit" label="eenheid" v-model="data.unit" :required-field="true"
                              placeholder="kies een eenheid" :options="unitOptions"
                              :warning="$v.data.unit.$error" @focus="$v.data.unit.$touch()"/>
        <!-- <dean-multi-select-form-row key="partnerAgreementTypes" id="partnerAgreementTypes" label="Partner types"
                                    placeholder="kies een partner type" :multiple="true"
                                    :options="partnerAgreementTypes"
                                    :value="currentTypes" @select="add($event, 'partnerAgreementTypes')"
                                    @remove="remove($event, 'partnerAgreementTypes')"></dean-multi-select-form-row> -->
        <dean-multi-select-form-row :multiple="true"
                                      placeholder="Partner types"
                                      id="partnerAgreementTypes"
                                      label="Partner types"
                                      :value="selectedTypes" :options='availablePartnerAgreementTypes'
                                      @select='addType'
                                      @remove="removeType"></dean-multi-select-form-row>
      </div>
    </dean-two-column-layout>
  </div>
</template>

<script lang="ts">
import {Vue, Component} from 'vue-property-decorator';
import axios from 'axios';
import {
  deanSectionTitle,
  deanSectionTitleItem,
  saveIcon,
} from '@deanone/dean-components';
import DeanFormRow from '@/components/deanComponents/deanFormRow.vue';
import DeanTwoColumnLayout from '@/components/deanComponents/deanTwoColumnLayout.vue';
import DeanSelectFormRow from '@/components/deanComponents/deanSelectFormRow.vue';
import deanMultiSelectFormRow from '@/components/deanComponents/deanMultiSelectFormRow.vue';
import {validationMixin} from 'vuelidate';
import {required, minValue} from 'vuelidate/lib/validators';
import {Validations} from 'vuelidate-property-decorators';
import {createNotification} from '@/mixins/validations';

@Component({
  components: {
    deanSectionTitle,
    deanSectionTitleItem,
    DeanFormRow,
    DeanTwoColumnLayout,
    DeanSelectFormRow,
    deanMultiSelectFormRow,
  },
  mixins: [validationMixin],
})
export default class Details extends Vue {
  // DATA
  public data: any = {
    name: null,
    length: null,
    unit: null,
    partnerAgreementTypes: [],
  };
  public saveIcon: any = saveIcon;
  public partnerAgreementTypes: any[] = [];
  public availablePartnerAgreementTypes: any[] = [];
  public unitOptions: string[] = [
    'DAY',
    'WEEK',
    'MONTH',
    'YEAR',
  ];

  // COMPUTED
  @Validations()
  get validations() {
    return {
      data: {
        name: {required},
        length: {required, minValue: minValue(0)},
        unit: {required},
      },
    };
  }

  get selectedTypes() {
    this.updateAvailablePartnerAgreementTypeOptions();
    return this.data.partnerAgreementTypes;
  }

  public addType(field: any) {
    this.data.partnerAgreementTypes.push(field);
    this.updateAvailablePartnerAgreementTypeOptions();
  }

  public removeType(field: any) {
    this.data.partnerAgreementTypes = this.data.partnerAgreementTypes.filter((partnerAgreementType: any) => {
        if (partnerAgreementType.value !== field.value) {
          return partnerAgreementType;
        }
    });
    this.updateAvailablePartnerAgreementTypeOptions();
  }

  public updateAvailablePartnerAgreementTypeOptions() {
    if (this.data.partnerAgreementTypes.length <= 0) {
      this.availablePartnerAgreementTypes = this.partnerAgreementTypes;
      return;
    }

    const selectedTypes: any[] = [];

    this.data.partnerAgreementTypes.forEach((type: any) => {
      selectedTypes[type.value] = type.label;
    });

    this.availablePartnerAgreementTypes = this.partnerAgreementTypes.filter((partnerAgreementType: any) => {
      if (selectedTypes[partnerAgreementType.value] === undefined) {
        return partnerAgreementType;
      }
    });
  }

  get headerTitle(): string {
    return (this.$route.params.id !== undefined) ? 'Producttermijn wijzigen' : 'Producttermijn toevoegen';
  }

  get sideMenu() {
    return {
      content: {
        title: {
          text: 'Productterm ' + (this.data.name ? this.data.name : ''),
        },
        type: 'themed',
        sections: {
          backToProductTerms: {
            items: {
              products: {
                title: 'Terug naar producttermijnen',
                name: 'standingData.productTerms',
              },
            },
          },
        },
      },
    };
  }

  public save() {
    this.$v.$touch();
    if (!this.$v.$invalid) {
      this.$store.dispatch('setLoadOverlay', true);

      this.$store.dispatch('processProductTerm', {
        id: this.$route.params.id,
        data: this.data,
      })
      .then(
        (response: any) => {
          this.$toast(this.$store.state.main.notification.messages.dataSaved);
        },
        (error: any) => {
          this.$toast(this.$store.state.main.notification.messages.couldNotSendData);
        },
      )
      .finally(() => {
        this.$store.dispatch('updateSideMenu', this.sideMenu);
        this.$store.dispatch('setLoadOverlay', false);
      });
    } else {
      this.$toast(createNotification(this.$v));
    }
  }

  public created() {
    this.$store.dispatch('updateSideMenu', this.sideMenu);
    this.$store.dispatch('setLoadOverlay', true);

    if (this.$route.params.id) {
      this.$store.dispatch('requestProductTerm', {
        id: this.$route.params.id,
        providerId: this.$route.params.id ? undefined : 'c2c286fa-f280-4763-b306-81cef170d73b',
      })
      .then(
        (response: any) => {
          this.data = {...this.data, ...response.data.data};

          this.data.partnerAgreementTypes = response.data.data.partnerAgreementTypes.map((pat: any) => {
            return {
              value: pat.id,
              label: pat.name,
            };
          });
        },
        (error: any) => {
          this.$toast(this.$store.state.main.notification.messages.couldNotReceiveData);
        },
      )
      .finally(() => {
        this.$store.dispatch('updateSideMenu', this.sideMenu);
        this.$store.dispatch('setLoadOverlay', false);
      });
    }

    this.$store.dispatch('requestPartnerAgreementTypes')
    .then(
      (partnerAgreementTypeResponse: any) => {
        this.partnerAgreementTypes = partnerAgreementTypeResponse.data.data.map((partnerAgreementType: any) => {
          return {
            value: partnerAgreementType.id,
            label: partnerAgreementType.name,
          };
        });
      },
      (error: any) => {
        this.$toast(this.$store.state.main.notification.messages.couldNotReceiveData);
      },
    )
    .finally(() => {
      this.$store.dispatch('updateSideMenu', this.sideMenu);
      this.$store.dispatch('setLoadOverlay', false);
    });
  }
}
</script>

<style lang="scss" scoped>

</style>
